import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill";

import {
  editLocationsService,
  uploadFileService,
  getLocationByIdService,
} from "../../service";

const UpdateLocationPage = () => {
  const location = useLocation();
  const locationId = parseInt(location.pathname.match(/\d+$/)[0]);

  const [name, setName] = useState("");
  const [sortingOrder, setSortingOrder] = useState("");
  const [image, setImage] = useState("");
  const [phone_no, setPhone_no] = useState("");
  const [web_url, setWeb_url] = useState("");
  const [address, setAddress] = useState("");
  const [sevenroom_url, setSevenroom_url] = useState("");
  const [schedule, setSchedule] = useState("");
  const [description, setDescription] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [insta_url, setInsta_url] = useState("");
  const [fb_url, setFb_url] = useState("");
  const [linkedin_url, setLinkedin_url] = useState("");

  const [nameErr, setNameErr] = useState("");
  const [sortingOrderErr, setSortingOrderErr] = useState("");
  const [imageErr, setImageErr] = useState("");
  const [phone_noErr, setPhone_noErr] = useState("");
  const [web_urlErr, setWeb_urlErr] = useState("");
  const [addressErr, setAddressErr] = useState("");
  const [sevenroom_urlErr, setSevenroom_urlErr] = useState("");
  const [scheduleErr, setScheduleErr] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [latitudeErr, setLatitudeErr] = useState("");
  const [longitudeErr, setLongitudeErr] = useState("");
  const [insta_urlErr, setInsta_urlErr] = useState("");
  const [fb_urlErr, setFb_urlErr] = useState("");
  const [linkedin_urlErr, setLinkedin_urlErr] = useState("");

  const [btnLoader, setBtnLoader] = useState(false);

  useEffect(() => {
    if (locationId) {
      let query = `/${locationId}`;
      getLocationByIdService(query).then((res) => {
        console.log(res, "resresresres");
        if (res.status == 200) {
          let _res = res.data.responseData;
          setName(_res.name);
          setSortingOrder(_res.sorting_order);
          setPhone_no(_res.phone_no);
          setWeb_url(_res.web_url);
          setAddress(_res.address);
          setSevenroom_url(_res.sevenroom_url);
          setSchedule(_res.schedule);
          setDescription(_res.description);
          setLatitude(_res.latitude);
          setLongitude(_res.longitude);
          setInsta_url(_res.insta_url);
          setFb_url(_res.fb_url);
          setLinkedin_url(_res.linkedin_url);
          setImage(_res.image);
        }
      });
    }
  }, [locationId]);

  const handleFileChange = (e) => {
    setImageErr("");
    let params = new FormData();
    params.append("image", e.target.files[0]);
    uploadFileService(params).then((res) => {
      if (res.status == 200) {
        setImage(res.data.responseData);
      }
    });
  };

  const handleSortingOrderChange = (e) => {
    const value = e.target.value;

    // Allow empty string for clearing the field
    if (value === "") {
      setSortingOrder("");
      setSortingOrderErr("");
      return;
    }

    // Check if it's a valid positive integer
    const num = parseInt(value, 10);
    if (!isNaN(num) && num >= 1 && num.toString() === value) {
      setSortingOrder(value);
      setSortingOrderErr("");
    } else {
      setSortingOrderErr("Sorting order must be an integer from 1 or greater");
    }
  };

  const handleValidate = () => {
    let validate = true;

    if (name == "" || name == "undefined" || name == null) {
      setNameErr("Name is required");
      validate = false;
    }

    return validate;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (handleValidate()) {
      setBtnLoader(true);
      let params = {
        name,
        sorting_order: parseInt(sortingOrder, 10),
        image,
        phone_no,
        web_url,
        address,
        sevenroom_url,
        schedule,
        description,
        latitude,
        longitude,
        insta_url,
        fb_url,
        linkedin_url,
      };

      let query = `/${locationId}`;

      editLocationsService(query, params).then((res) => {
        setBtnLoader(false);
        if (res.status == 200) {
          window.location = "/locations";
        }
      });
    }
  };

  return (
    <div className="page_wrapper px-4 py-5">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="form-group col-md-4">
            <label>Name</label>
            <input
              className={`form-control ${nameErr ? "is-invalid" : ""}`}
              type="text"
              value={name}
              onChange={(e) => (setName(e.target.value), setNameErr(""))}
            />

            {nameErr ? <div className="invalid-feedback">{nameErr}</div> : ""}
          </div>

          <div className="form-group col-md-4">
            <label>Sorting Order</label>
            <input
              className={`form-control ${sortingOrderErr ? "is-invalid" : ""}`}
              type="number"
              min="1"
              step="1"
              value={sortingOrder}
              onChange={handleSortingOrderChange}
              onWheel={(e) => e.target.blur()}
            />

            {sortingOrderErr ? (
              <div className="invalid-feedback">{sortingOrderErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Phone No</label>
            <input
              className={`form-control ${phone_noErr ? "is-invalid" : ""}`}
              type="text"
              value={phone_no}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "" || /^[^a-zA-Z]*$/.test(val)) {
                  setPhone_no(val);
                  setPhone_noErr("");
                }
              }}
              onWheel={(e) => e.target.blur()}
            />

            {phone_noErr ? (
              <div className="invalid-feedback">{phone_noErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Web url</label>
            <input
              className={`form-control ${web_urlErr ? "is-invalid" : ""}`}
              type="text"
              value={web_url}
              onChange={(e) => (setWeb_url(e.target.value), setWeb_urlErr(""))}
            />

            {web_urlErr ? (
              <div className="invalid-feedback">{web_urlErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Address</label>
            <input
              className={`form-control ${addressErr ? "is-invalid" : ""}`}
              type="text"
              value={address}
              onChange={(e) => (setAddress(e.target.value), setAddressErr(""))}
            />

            {addressErr ? (
              <div className="invalid-feedback">{addressErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Sevenroom url</label>
            <input
              className={`form-control ${sevenroom_urlErr ? "is-invalid" : ""}`}
              type="text"
              value={sevenroom_url}
              onChange={(e) => (
                setSevenroom_url(e.target.value),
                setSevenroom_urlErr("")
              )}
            />

            {sevenroom_urlErr ? (
              <div className="invalid-feedback">{sevenroom_urlErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Schedule</label>
            <input
              className={`form-control ${scheduleErr ? "is-invalid" : ""}`}
              type="text"
              value={schedule}
              onChange={(e) => (
                setSchedule(e.target.value),
                setScheduleErr("")
              )}
            />

            {scheduleErr ? (
              <div className="invalid-feedback">{scheduleErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-12">
            <label>Description</label>
            <ReactQuill
              className={`${descriptionErr ? "is-invalid" : ""}`}
              theme="snow"
              value={description}
              onChange={(e) => (setDescription(e), setDescriptionErr(""))}
            />
            {descriptionErr ? (
              <div className="invalid-feedback">{descriptionErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Latitude</label>
            <input
              className={`form-control ${latitudeErr ? "is-invalid" : ""}`}
              type="text"
              value={latitude}
              onChange={(e) => (
                setLatitude(e.target.value),
                setLatitudeErr("")
              )}
            />

            {latitudeErr ? (
              <div className="invalid-feedback">{latitudeErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Longitude</label>
            <input
              className={`form-control ${longitudeErr ? "is-invalid" : ""}`}
              type="text"
              value={longitude}
              onChange={(e) => (
                setLongitude(e.target.value),
                setLongitudeErr("")
              )}
            />

            {longitudeErr ? (
              <div className="invalid-feedback">{longitudeErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Instagram url</label>
            <input
              className={`form-control ${insta_urlErr ? "is-invalid" : ""}`}
              type="text"
              value={insta_url}
              onChange={(e) => (
                setInsta_url(e.target.value),
                setInsta_urlErr("")
              )}
            />

            {insta_urlErr ? (
              <div className="invalid-feedback">{insta_urlErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Facebook url</label>
            <input
              className={`form-control ${fb_urlErr ? "is-invalid" : ""}`}
              type="text"
              value={fb_url}
              onChange={(e) => (setFb_url(e.target.value), setFb_urlErr(""))}
            />

            {fb_urlErr ? (
              <div className="invalid-feedback">{fb_urlErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-4">
            <label>Linkedin url</label>
            <input
              className={`form-control ${linkedin_urlErr ? "is-invalid" : ""}`}
              type="text"
              value={linkedin_url}
              onChange={(e) => (
                setLinkedin_url(e.target.value),
                setLinkedin_urlErr("")
              )}
            />

            {linkedin_urlErr ? (
              <div className="invalid-feedback">{linkedin_urlErr}</div>
            ) : (
              ""
            )}
          </div>

          <div className="form-group col-md-6">
            <label>Image</label>
            <input
              className={`form-control ${imageErr ? "is-invalid" : ""}`}
              type="file"
              onChange={handleFileChange}
            />

            {imageErr ? <div className="invalid-feedback">{imageErr}</div> : ""}
            {image ? <img className="event_img" src={image} /> : ""}
          </div>
        </div>

        <div>
          <button
            disabled={btnLoader}
            className="btn btn-primary px-5"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateLocationPage;
